import React, { useEffect } from 'react';
import { useAction, useSelect } from 'hooks';
import { Loader, Card, Search, SortBy } from 'components';
// import { Link } from 'react-router-dom';
import ContainerTransactionItem from './ContainerTransactionItem';

const ContainerTransactionHistory = () => {

  const getList = useAction('payment.getList')
  const liting = useSelect('loading.isLoading', { type: 'payment.getList' })
  const list = useSelect('payment.list')
  const order = useSelect('payment.order')

  useEffect(() => {
    getList({ sort_by: 'desc' })
    // eslint-disable-next-line
  }, [])
  
  return (
    <Card className="transaction-history">
      <Card.Header>
        <div className="content">
          <b className="title font-medium">Transaction History</b>
          <SortBy />
        </div>
      </Card.Header>  
      <Card.Body>
        <Search />
        {liting && <Loader.Table />}
        {!liting && order.map(i => {
          const payment = list[i] || {}
          return (
            <div className="mt-5" key={`TransctionHistoryItem${payment.id}`}>
              <ContainerTransactionItem key={`transactionItem${payment.id}`} data={payment}/>
            </div>
          )
        })}
      </Card.Body>            
    </Card>
  )
}

export default ContainerTransactionHistory